
import React from 'react';

interface CampaignFormHeaderProps {
  onUseDemoData: () => void;
  onExportCurrentData?: () => void;
}

const CampaignFormHeader: React.FC<CampaignFormHeaderProps> = ({
  onUseDemoData,
  onExportCurrentData
}) => {
  return (
    <div className="text-center mb-8">
      <div className="border-2 border-red-600 inline-block p-4 mb-4">
        <h2 className="text-xl font-bold text-red-700 tracking-wider">
          POLITICAL CAMPAIGN
          <br />
          PLANNING FORM
        </h2>
      </div>
      
      {/* Demo Data Buttons */}
      <div className="mt-4 space-y-3">
        <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
          <button
            type="button"
            onClick={onUseDemoData}
            className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 font-medium transition-colors"
          >
            Use Demo Data
          </button>
          
          {onExportCurrentData && (
            <button
              type="button"
              onClick={onExportCurrentData}
              className="px-6 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 font-medium transition-colors"
            >
              Export Current Data
            </button>
          )}
        </div>
        
        <p className="text-sm text-neutral-600">
          {onExportCurrentData 
            ? "Use demo data for testing or export current data as new demo template"
            : "Click to populate the form with sample campaign data for quick testing"
          }
        </p>
      </div>
    </div>
  );
};

export default CampaignFormHeader;
